import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { CustomIconButton, icon } from "../../../../../../common/components";
import OptionsDropDown from "./components/OptionsDropDown";
import { checkReqValMode } from "../../../../utils/utils";
import styles from "./Options.module.css";
import { environmentSwitch } from "../../../../../../common/providers";

export default function Options() {
	const optionsRef = useRef();
	const [open, setOpen] = useState(false);
	const mode = useSelector(({ srDocument }) => srDocument.mode);
	const handleDropdown = () => {
		setOpen((prev) => !prev);
	};
	const hasActionPermission = environmentSwitch({
		main: checkReqValMode(mode),
		veolia: true,
	});
	return (
		<>
			{hasActionPermission && (
				<>
					<CustomIconButton
						ref={optionsRef}
						className={styles.menuBtn}
						icon={icon.faSliders}
						size="sm"
						variant="outlined"
						onClick={handleDropdown}
					/>
					<OptionsDropDown ref={optionsRef} open={open} onClose={handleDropdown} />
				</>
			)}
		</>
	);
}
